import React, { useState, useEffect } from "react";
import "../../assets/css/bootstrap.min.css";
import DoctorImage from "./images/doctor.webp";
import { Link } from 'react-router-dom';

const AboutDoctor = () => {
  const [videos, setVideos] = useState([]);
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const [loading, setLoading] = useState(true);

  

  	return (
    <section class="doct">
		<style>
		{`
		.doct {
			font-family: 'Teachers', sans-serif !important;
			background-color: #fff;
			margin: 0;
			padding: 0;
		}
		@media (min-width: 768px) {
			.container-flex {
				display: flex;
				align-items: center;
				justify-content: space-between;
				gap: 5rem;
				max-width: 1200px;
				margin: 4rem auto;
				padding: 0 1.5rem;
			}
		}
		@media (min-width: 768px) {
			.text-content {
				max-width: 600px;
			}
		}
		h2 {
			font-weight: 600;
			font-size: 40px;
			margin-bottom: 1.5rem;
			align-center: center !important;
		}
		.text-gray {
			color: #4a4a4a;
			style: "font-size: 1rem; line-height: 1.5";
		}
		.font-semibold {
			font-weight: 700;
		}
		.btn-readmore {
			background-color: #0F995F;
			color: #fff;
			font-weight: 600;
			font-size: 0.75rem;
			text-transform: uppercase;
			padding: 0.625rem 1.25rem;
			border-radius: 0.25rem;
			display: inline-flex;
			align-items: center;
			gap: 0.5rem;
			border: none;
			cursor: pointer;
			transition: background-color 0.3s ease;
		}
		.btn-readmore svg {
			stroke: currentColor;
			stroke-width: 3;
			width: 0.75rem;
			height: 0.75rem;
		}
		.image-container {
			background-color: #dff3eb;
			border-radius: 0.375rem;
			padding: 1rem;
			max-width: 320px;
			margin: 0 auto;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		@media (min-width: 768px) {
			.image-container {
				margin: 0;
				max-width: none;
				flex-shrink: 0;
			}
		}
		.image-container img {
			border-radius: 0.375rem;
			width: 100%;
			height: auto;
			object-fit: contain;
			display: block;
			max-height: 400px;
		}

		`}
		</style>

        <div class="container-flex">

          <div class="text-content  align-items-center">
            <h2>ABOUT THE DOCTOR</h2>
            <p class="text-gray mb-3" >
              MedFirst ENT Centre was established in 1997. Since then it has undergone regular improvements and upgradation to become a centre of excellence for the diagnosis and management of ENT disorders in the NCR. We get patients from all over India and overseas as well. We offer the latest technology and equipment and expertise in the management of ENT diseases.
            </p>
            <p class="text-gray font-semibold mb-4" >
              <strong>Dr. (Major) Rajesh Bhardwaj MBBS (AFMC), MS, DNB, DLO, DHA</strong>
            </p>
            <Link class="btn-readmore" to="/about-doctor-rajesh-bhardwaj/">
              READ MORE
              <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M9 5l7 7-7 7" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </Link>
          </div>
          <div class="image-container" aria-label="Doctor's portrait background">
            <img src="/static/media/Dr-Rajesh-Bhardwaj..ba39b548b45da76b6b4f.ba39b548b45da76b6b4f.png" alt="Portrait of a serious middle-aged male doctor wearing a green surgical cap and teal scrubs, looking directly at the camera" />
          </div>
        </div>


      </section>
  );
};

export default AboutDoctor;